/**
 * @generated SignedSource<<5eeda6d651a2b214293767fe20f183f3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_softwareReleasesApprovers_Approvers$data = {
  readonly approvers: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"taskApprover_softwareReleasesApprovers_jiraVersionApprover">;
      } | null | undefined;
    } | null | undefined>;
  };
  readonly canAddAndRemoveIssues: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"approverSelector_softwareReleasesApprovers" | "taskApprover_softwareReleasesApprovers_jiraVersion">;
  readonly " $fragmentType": "ui_softwareReleasesApprovers_Approvers";
};
export type ui_softwareReleasesApprovers_Approvers$key = {
  readonly " $data"?: ui_softwareReleasesApprovers_Approvers$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesApprovers_Approvers">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "approvers"
        ]
      }
    ]
  },
  "name": "ui_softwareReleasesApprovers_Approvers",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "canAddAndRemoveIssues"
    },
    {
      "kind": "FragmentSpread",
      "name": "approverSelector_softwareReleasesApprovers"
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": "approvers",
        "concreteType": "JiraVersionApproverConnection",
        "kind": "LinkedField",
        "name": "__version_approvers_connection",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "concreteType": "JiraVersionApproverEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraVersionApprover",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "id"
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "taskApprover_softwareReleasesApprovers_jiraVersionApprover"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "__typename"
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "cursor"
                }
              ]
            },
            "action": "THROW",
            "path": "approvers.edges"
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "endCursor"
              },
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              }
            ]
          }
        ]
      },
      "action": "THROW",
      "path": "approvers"
    },
    {
      "kind": "FragmentSpread",
      "name": "taskApprover_softwareReleasesApprovers_jiraVersion"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "6bdf5e27e22a0c4638dba83dd47602fd";

export default node;
